

function getCurrentTimestamp() {
    return Date.now();
}

const formatTimestampWithOutComma = (timestamp: number) => {
  const date = new Date(timestamp);

const parts = date.toLocaleString('en-IN', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
}).split(','); // splits into [ "11 April 2025", " 14:30" ]

const cleanFormat = parts.join(''); // remove the comma

    return cleanFormat;
  };

  const formatTimestamp = (timestamp: number) => {
    return new Date(timestamp).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false, // Ensures 24-hour format
    }).replace(',', ''); // Removes unwanted comma
  };


  const formatTimestampSeprate = (timestamp: number) => {
    const date = new Date(timestamp);
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-IN', { month: 'long' });
    const year = date.getFullYear();
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
  
    return `${day} ${month}, ${hour}:${minute}`;
  }

  const formatTimeExpireIn = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
  
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };
  

  const formatRemainingSeconds = (ms: any) => {
    const totalSeconds = Math.floor(ms / 1000);
  
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

export { getCurrentTimestamp, formatTimestamp,formatTimestampWithOutComma, formatTimestampSeprate, formatRemainingSeconds, formatTimeExpireIn };